<template>
  <div>
    <main-header />
    <b-container>
      <b-row>
        <b-col md="12" xl="3" class="nav-col">
          <main-nav />
        </b-col>
        <b-col class="mt-4">
          <slot/>
        </b-col>
      </b-row>
    </b-container>
    <main-footer />
  </div>
</template>

<script>
  import MainHeader from '@/components/layout/MainHeader.vue'
  import MainNav from '@/components/layout/MainNav.vue'
  import MainFooter from '@/components/layout/MainFooter.vue'

  export default {
    components: {
      MainHeader,
      MainNav,
      MainFooter
    }
  }
</script>

<style lang="scss" scoped>
  .nav-col{
    max-width: 300px;
    padding-left: 0;
    padding-right: 0;

    @include media-breakpoint-down(md) {
      max-width: 100%;
    }

    @include media-breakpoint-up(lg) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
</style>
